import { store } from '@/app/store';
import OidcLoadingFallback from '@/components/OidcLoadingFallback';
import Ribbon from '@/components/ribbon/Ribbon';
import { tolgee } from '@/i18n/tolgee';
import router from '@/router';
import AuthGate from '@/shared/auth/AuthGate';
import { OidcInitializationGate } from '@/shared/auth/oidc';
import { defaultLocale } from '@/shared/utils/date-utils';
import { theme } from '@/theme';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { NavigationProgress } from '@mantine/nprogress';
import { TolgeeProvider } from '@tolgee/react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

const App = () => {
  return (
    <TolgeeProvider tolgee={tolgee} fallback={null}>
      <Provider store={store}>
        <MantineProvider theme={theme} defaultColorScheme="light">
          <ModalsProvider>
            <NavigationProgress />
            <Notifications
              position="top-center"
              autoClose={6000}
              styles={{
                notification: {
                  borderWidth: 2,
                  boxShadow: '0 6px 18px rgba(0, 0, 0, 0.18)',
                  fontWeight: 600,
                },
              }}
            />
            <DatesProvider settings={{ locale: defaultLocale }}>
              <OidcInitializationGate fallback={<OidcLoadingFallback />}>
                <AuthGate>
                  <Ribbon />
                  <RouterProvider router={router} />
                </AuthGate>
              </OidcInitializationGate>
            </DatesProvider>
          </ModalsProvider>
        </MantineProvider>
      </Provider>
    </TolgeeProvider>
  );
};

export default App;
